import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LangContext";
import { LOGO_URL, CONTACT } from "@/lib/constants";
import { Phone, MessageCircle, Instagram, Facebook, MapPin } from "lucide-react";

export default function Footer() {
  const { t, lang } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 fl-mint-panel border-t border-emerald-900/10">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="FLUORIT" className="h-14 w-14 object-contain rounded-lg bg-white p-1 border border-emerald-900/10" />
            <div>
              <div className="text-lg font-extrabold tracking-tight text-emerald-950">FLUORIT</div>
              <div className="text-xs text-emerald-900/70">{t.footer.about}</div>
            </div>
          </div>
          <p className="text-sm text-slate-700 leading-relaxed max-w-md">
            {lang === "ar" ? "نستثمر في الأرض .. ونبني قيمة للمستقبل" : t.footer.tagline}
          </p>
          <div className="flex items-start gap-2 text-sm text-slate-700">
            <MapPin className="w-4 h-4 mt-0.5 text-amber-700" />
            <span>{lang === "ar" ? CONTACT.address_ar : CONTACT.address_en}</span>
          </div>
        </div>

        <div>
          <div className="text-sm font-semibold text-emerald-900 mb-3">{t.footer.quick}</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/" className="hover:text-amber-700">{t.nav.home}</Link></li>
            <li><Link to="/properties" className="hover:text-amber-700">{t.nav.properties}</Link></li>
            <li><Link to="/sell" className="hover:text-amber-700">{t.nav.add}</Link></li>
            <li><Link to="/ai-property-assistant" className="hover:text-amber-700">🤖 مساعد فلوريت العقاري</Link></li>
            <li><Link to="/favorites" className="hover:text-amber-700">{t.nav.favs}</Link></li>
            <li><Link to="/login" className="hover:text-amber-700">{t.nav.login}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-emerald-900 mb-3">{t.footer.contact}</div>
          <ul className="space-y-3 text-sm text-slate-700">
            <li><a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2 hover:text-amber-700"><Phone className="w-4 h-4" /> {CONTACT.phone}</a></li>
            <li><a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-amber-700"><MessageCircle className="w-4 h-4" /> WhatsApp</a></li>
            <li><a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-amber-700"><Instagram className="w-4 h-4" /> Instagram</a></li>
            <li><a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-amber-700"><Facebook className="w-4 h-4" /> Facebook</a></li>
          </ul>
          <div className="mt-6 text-sm font-semibold text-emerald-900 mb-2">قانوني</div>
          <ul className="space-y-2 text-sm text-slate-700">
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-amber-700">الشروط والأحكام</Link></li>
            <li><Link to="/disclaimer" data-testid="footer-disclaimer" className="hover:text-amber-700">إخلاء المسؤولية</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-amber-700">سياسة الخصوصية</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-emerald-900/10 py-4 text-center text-xs text-slate-500">
        © {year} FLUORIT · {t.footer.rights}
      </div>
    </footer>
  );
}
